export default "__VITE_ASSET__CYp$UCR1__"